import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListProductsRequest, ListProductsResponse, MatchProductsRequest, MatchProductsResponse, SearchProductsRequest, SearchProductsResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const productApi = createApi({
    reducerPath: "productApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listProducts: builder.query<ListProductsResponse, ListProductsRequest>({
            query: body => ({
                url: "product/list",
                method: "POST",
                body
            })
        }),
        searchProducts: builder.query<SearchProductsResponse, SearchProductsRequest>({
            query: body => ({
                url: "product/search",
                method: "POST",
                body
            })
        }),
        matchProducts: builder.query<MatchProductsResponse, MatchProductsRequest>({
            query: body => ({
                url: "product/match",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListProductsQuery,
    useSearchProductsQuery,
    useMatchProductsQuery,
    useLazySearchProductsQuery,
    useLazyListProductsQuery,
    useLazyMatchProductsQuery
} = productApi;
